import { apiDelete, apiGet, apiPatch, apiPost } from './client.js';

export type Supplier = {
  id: string;
  tenantId?: string;
  name: string;
  website?: string | null;
  accountNumber?: string | null;
  contactName?: string | null;
  contactEmail?: string | null;
  contactPhone?: string | null;
  address?: string | null;
  paymentTerms?: string | null;
  defaultLeadTimeDays?: number | null;
  notes?: string | null;
  active?: boolean;
  itemCount?: number;
  openPoCount?: number;
  createdAt?: string;
  updatedAt?: string;
};

export type SupplierInput = {
  name: string;
  website?: string | null;
  accountNumber?: string | null;
  contactName?: string | null;
  contactEmail?: string | null;
  contactPhone?: string | null;
  address?: string | null;
  paymentTerms?: string | null;
  defaultLeadTimeDays?: number | null;
  notes?: string | null;
  active?: boolean;
};

export function listSuppliers(params?: { q?: string; active?: boolean | 'all' }) {
  const query: Record<string, string> = {};
  if (params?.q) query.q = params.q;
  if (params?.active === 'all') query.active = 'all';
  else if (params?.active === false) query.active = 'false';
  else if (params?.active === true) query.active = 'true';
  return apiGet<Supplier[]>('/api/v1/suppliers', { params: query }).then((res) => res.data);
}

export function createSupplier(body: SupplierInput) {
  return apiPost<Supplier, SupplierInput>('/api/v1/suppliers', body).then((res) => res.data);
}

export function updateSupplier(id: string, body: Partial<SupplierInput>) {
  return apiPatch<Supplier, Partial<SupplierInput>>(`/api/v1/suppliers/${id}`, body).then(
    (res) => res.data,
  );
}

export function deleteSupplier(id: string, opts?: { hard?: boolean }) {
  return apiDelete<Supplier | null>(`/api/v1/suppliers/${id}`, {
    params: opts?.hard ? { hard: 'true' } : undefined,
  }).then((res) => res.data);
}
